export default {
    //Splash
    splash_message: 'संचार और प्रशिक्षण प्लेटफार्म',

    //TTCC
    accept_ttcc: 'नियम और शर्तें स्वीकार करें',

    //Login
    welcome: 'स्वागत है!',
    welcome_message: 'डॉट्स, संचार और प्रशिक्षण में आपका नया तकनीकी सहयोगी।',
    username: 'उपयोगकर्ता नाम',
    password: 'पासवर्ड',
    code: 'कोड',
    recover_password: 'पासवर्ड पुनर्प्राप्त करें',
    log_in: 'लॉग इन करें',
    log_in_biometrics: 'बायोमेट्रिक डेटा के साथ लॉगिन करें',
    create_user: 'उपयोगकर्ता बनाएं',
    recover_access_to_account: 'अपने खाते तक पहुंच पुनः प्राप्त करने के लिए अपना उपयोगकर्ता नाम दर्ज करें',
    back: 'वापस',
    enter_new_password: 'कोड और अपना नया पासवर्ड दर्ज करें',
    enter_code: 'कोड दर्ज करें',
    new_password: 'नया पासवर्ड',
    repeat_new_password: 'नया पासवर्ड दोहराएं',
    validate: 'सत्यापित करें',
    complete_all_fields: 'सभी फ़ील्ड भरें',
    passwords_do_not_match: 'पासवर्ड मेल नहीं खाते',
    user_created_successfully: 'उपयोगकर्ता सफलतापूर्वक बनाया गया',
    create_user: 'उपयोगकर्ता बनाएं',
    required_fields: 'आवश्यक फ़ील्ड',
    confirm_your_email: 'अपना ईमेल पुष्टि करें',
    confirm_your_phone: 'अपने फोन की पुष्टि करें',
    confirm_password: 'पासवर्ड की पुष्टि करें',
    modifying_email: 'आप अपना ईमेल बदल रहे हैं',
    validate_code: 'कोड सत्यापित करें',
    code_sent_successfully: 'कोड सफलतापूर्वक भेजा गया',
    password_reset: 'आपका पासवर्ड सफलतापूर्वक रीसेट हो गया है',
    enter_confirmation_code: 'अपना पुष्टि कोड दर्ज करें',
    enter_your_new_email: 'अपना नया ईमेल दर्ज करें',
    //nuevos al 01-08-2024
    user_does_not_exist: 'अरे! हमें आपका खाता नहीं मिला',
    contact_the_administrator:
        'लगता है कि आपने जो उपयोगकर्ता दर्ज किया है वह मौजूद नहीं है।\nसुनिश्चित करें कि यह सही ढंग से लिखा गया है\nया प्रशासक से संपर्क करें।',
    invalid_user_or_pass: 'अमान्य उपयोगकर्ता नाम और/या पासवर्ड',
    info_is_not_correct: 'कुछ जानकारी सही नहीं है, कृपया पुनः प्रयास करें।',
    enter_user: 'कृपया एक उपयोगकर्ता नाम दर्ज करें',
    nonexistent_user: 'अस्तित्वहीन उपयोगकर्ता। कृपया पुनः प्रयास करें।',
    incorrect_code: 'गलत कोड',
    change_saved_successfully: 'परिवर्तन सफलतापूर्वक सहेजा गया',
    pass_changed_successfully: 'पासवर्ड सफलतापूर्वक बदल दिया गया',
    check_your_email: 'मान्यकरण कोड दर्ज करने के लिए अपना ईमेल जांचें',
    eight_characters: '*8 वर्णों से अधिक होना चाहिए',
    one_uppercase_letter: '*कम से कम 1 बड़ा अक्षर होना चाहिए',
    one_special_character: '*कम से कम 1 विशेष वर्ण होना चाहिए (@,$,!,#,?)',
    pass_requirements:
        'आपको निम्नलिखित आवश्यकताओं को पूरा करना होगा:\n\n*8 वर्णों से अधिक होना चाहिए\n*कम से कम 1 बड़ा अक्षर होना चाहिए\n*कम से कम 1 विशेष वर्ण होना चाहिए (जैसे: $, !, #, ?)',
    select_date: 'कृपया एक तारीख़ चुनें',
    cannot_create_password: 'पासवर्ड नहीं बना सकते',
    complete_your_details: 'जारी रखने के लिए कृपया अपनी जानकारी पूरी करें',
    validate_code: 'Validate code',
    enter_valid_number: 'कृपया एक मान्य संख्या दर्ज करें',
    complete_numbers: '"15" प्रीफिक्स को हटाना होगा ताकि अंतिम संख्या में कुल 13 अंक हों, उदाहरण: +54 9 XXX XXX XXXX, आपको शेष 10 अंक भरने होंगे।',

    //Profile
    insufficient_permissions: 'अपर्याप्त अनुमतियाँ',
    permissions_are_required: 'कैमरा और फोटो गैलरी तक पहुंचने के लिए अनुमतियाँ आवश्यक हैं।',
    choose_font: 'स्रोत चुनें',
    where_do_you_want: 'आप छवि को कहां से चुनना चाहते हैं?',
    camera: 'कैमरा',
    gallery: 'गैलरी',
    edit_photo: 'फोटो संपादित करें',
    cancel: 'रद्द करें',
    save: 'सहेजें',
    app: 'ऐप',
    support: 'समर्थन',
    other: 'अन्य',
    contact_channel: 'संपर्क चैनल',
    select_the_contact_channel: 'संपर्क चैनल चुनें',
    subject: 'विषय',
    write_the_subject: 'विषय लिखें',
    message: 'संदेश',
    write_a_comment: 'एक टिप्पणी लिखें',
    send: 'भेजें',
    sent_successfully: 'सफलतापूर्वक भेजा गया',
    thank_you_for_leaving_us_your_comments: 'हमें अपनी टिप्पणियाँ देने के लिए धन्यवाद, जल्द ही आपसे संपर्क किया जाएगा।',
    close: 'बंद करें',
    check_for_update: 'अपडेट की जांच करें',
    clear_cache: 'कैश साफ़ करें',
    delete_account: 'खाता हटाएं',
    log_out: 'लॉग आउट करें',
    notifications: 'सूचनाएं',
    insufficient_permissions: 'अपर्याप्त अनुमतियाँ',
    permissions_to_access: 'कैमरा और फोटो गैलरी तक पहुंचने के लिए अनुमतियाँ आवश्यक हैं।',
    choose_font: 'स्रोत चुनें',
    select_the_image: 'आप छवि को कहां से चुनना चाहते हैं?',
    change_language: 'भाषा बदलें',
    change_language_title: 'महत्वपूर्ण!',
    change_language_message:
        'इस क्रिया को करने के लिए इंटरनेट कनेक्शन का होना आवश्यक है। इससे ऑफ़लाइन उपयोग के लिए डाउनलोड की गई सामग्री हटा दी जाएगी. कृपया ध्यान दें कि परिवर्तन केवल ऐप की सामग्री को प्रभावित करेगा, न कि ऐप की संरचना को, जो आपके डिवाइस की भाषा पर निर्भर करता है।',
    logout_not_available: 'लॉगआउट उपलब्ध नहीं है',
    cant_logout: 'आप इस समय लॉगआउट नहीं कर सकते क्योंकि आपका इंटरनेट कनेक्शन नहीं है। कृपया अपना कनेक्शन जांचें और पुनः प्रयास करें।',
    //nuevos al 01-08-2024
    cache_cleared: 'कैश सफलतापूर्वक साफ़ हो गया',
    deletes_the_content:
        'यह क्रिया ऑफ़लाइन मोड में ऐप के उपयोग के लिए डाउनलोड की गई सामग्री को हटा देती है। सुनिश्चित करें कि आप ब्राउज़िंग जारी रखने के लिए कनेक्ट हैं।',
    error_uploading_image: 'छवि अपलोड करने में त्रुटि: ',
    there_was_an_error: 'छवि अपलोड करने में एक त्रुटि हुई। कृपया फिर से प्रयास करें।',
    //nuevos al 21-11-2024
    email: 'ईमेल',
    phone: 'फोन',
    name: 'नाम',
    last_name: 'उपनाम',
    role: 'भूमिका',
    verify: 'सत्यापित करें',
    verified: 'सत्यापित',
    contact_channels: 'संपर्क चैनल',
    editing_your_email: 'आप अपना ईमेल संपादित कर रहे हैं',
    editing_your_phone: 'आप अपना फोन नंबर संपादित कर रहे हैं',
    modifying_your_email:
        'आप अपना ईमेल बदल रहे हैं, आपको इसे दर्ज करने के लिए अपने ईमेल पर एक कोड प्राप्त होगा। यदि आपने अभी तक कोड प्राप्त नहीं किया है, तो कृपया फिर से जांचें।',
    modifying_your_phone:
        'आप अपना मोबाइल नंबर बदल रहे हैं, आपको इसे दर्ज करने के लिए एसएमएस द्वारा एक कोड प्राप्त होगा। यदि आपने अभी तक कोड प्राप्त नहीं किया है, तो कृपया फिर से जांचें।',

    //Notifications
    all: 'सभी',
    unread: 'अपठित',
    read: 'पढ़ें',
    seen: 'देखा गया',
    notifications: 'सूचनाएं',
    here_you_will_find: 'यहां आपको सभी अलर्ट और सूचनाएं मिलेंगी!',
    mark_all_read: 'सभी को पढ़ा हुआ चिह्नित करें',
    you_have_no_notifications: 'आपके पास कोई सूचनाएं नहीं हैं!',
    you_will_soon_start: 'आप जल्द ही नई संचार प्राप्त करना शुरू करेंगे',

    //Buscador
    enter_your_search: 'अपनी खोज दर्ज करें',
    no_results: 'कोई परिणाम नहीं',
    search_content: 'विषयवस्तु की खोज करें जो आपको रुचिकर हो।',
    see: 'देखें',
    results_in: 'में परिणाम',
    see_less_results: 'कम परिणाम देखें',
    all: 'सभी',
    wall: 'दीवार',
    learning: 'सीखना',
    benefits: 'लाभ',
    portfolio: 'पोर्टफोलियो',
    retry: 'पुनः प्रयास करें',
    locked: 'लॉक किया गया',
    pending: 'लंबित',
    seen: 'देखा गया',
    approved: 'स्वीकृत',

    //Posts
    see_them: 'सभी देखें ',
    _comments: ' टिप्पणियाँ',
    reactions_from_other_users: 'अन्य उपयोगकर्ताओं की प्रतिक्रियाएँ',
    not_connected_to_the_network: 'आप नेटवर्क से जुड़े नहीं हैं',
    comment: 'टिप्पणी करें',
    comments: 'टिप्पणियाँ',
    write_a_comment: 'एक टिप्पणी लिखें',
    no_content: 'कोई सामग्री नहीं',
    reaction: 'प्रतिक्रिया',
    reactions: 'प्रतिक्रियाएँ',
    first_comment: 'टिप्पणी करने वाले पहले व्यक्ति बनें!',
    no_comment: 'इस पोस्ट पर अभी तक कोई टिप्पणी नहीं है।',
    write_a_comment: 'एक टिप्पणी लिखें',
    no_publications: 'कोई प्रकाशन नहीं',
    no_post_to_read: 'आपके पास पढ़ने के लिए कोई पोस्ट नहीं है।',
    views: 'दृश्य',
    reply: 'उत्तर दें',
    see: 'देखें ',
    more_answers: 'अधिक उत्तर',
    hide: 'छिपाएं ',
    answers: ' उत्तर',
    no_reactions: 'अभी कोई प्रतिक्रियाएं नहीं हैं!',
    leave_your_reaction: 'अपनी प्रतिक्रिया देने वाले पहले व्यक्ति बनें।',
    leave_your_reaction: 'Be the first to leave your reaction.',
    //nuevos al 01-08-2024
    full_survey: 'आपने सर्वेक्षण पूरा कर लिया है!',
    thanks_for_participating: 'भाग लेने के लिए धन्यवाद! अधिक अपडेट के लिए दीवार पर नज़र रखें।',
    sent_automatically: 'जब आप पुनः कनेक्ट होंगे, तब इसे स्वचालित रूप से भेजा जाएगा।',
    no_post_saved: 'अभी कोई पोस्ट सहेजा नहीं गया है',
    see_your_favorite_content: 'यहां आपके पसंदीदा सामग्री दिखाई देंगी',
    //fechas
    instant: 'कुछ समय पहले',
    hourFirst: 'पहले ',
    hour: ' घंटा',
    hours: ' घंटे',
    day: ' दिन',
    days: ' दिन',

    //Learning
    congratulations: 'बधाई हो!',
    you_approved: 'आपने पास कर लिया है ',
    you_completed: 'आपने यह कोर्स पूरा कर लिया है',
    you_disapproved: 'अस्वीकृत मूल्यांकन',
    score: 'स्कोर:',
    return_to_course: 'घर वापस जाओ',
    retry: 'पुनः प्रयास करें',
    it_is_available: 'यह अब उपलब्ध है',
    total_course_evaluation: 'कुल कोर्स मूल्यांकन',
    evaluate_me: 'मुझे मूल्यांकन करें',
    completed_the_course: 'आपने कोर्स पूरा कर लिया है',
    pending_approval: 'स्वीकृति लंबित है',
    return: 'वापस',
    continue_course: 'कोर्स जारी रखें',
    you_have_made: 'आपने पूरा कर लिया है ',
    of_the_course: ' कोर्स का',
    locked: 'लॉक किया गया',
    pending: 'लंबित',
    seen: 'देखा गया',
    complete: 'पूरा करें',
    reprobate: 'असफल',
    sync_pend: 'सिंक लंबित',
    in_progress: 'प्रगति में',
    perform_evaluation: 'मूल्यांकन करें',
    next_content: 'अगली सामग्री',
    you_completed_all: 'आपने सभी सामग्री पूरी कर ली है',
    final_evaluation: 'अंतिम मूल्यांकन',
    retry_mayus: 'पुनः प्रयास करें',
    see_more: '...अधिक देखें',
    see_less: '...कम देखें',
    back_to_course: 'कोर्स पर वापस जाएं',
    click_to_see: 'देखने के लिए क्लिक करें',
    //Evaluaciones
    evaluation: 'मूल्यांकन: ',
    of: ' का ',
    loading_evaluation: 'मूल्यांकन लोड हो रहा है...',
    select_option: 'जारी रखने के लिए आपको एक विकल्प चुनना होगा',
    select_one_answer: 'कृपया प्रत्येक प्रश्न के लिए कम से कम एक उत्तर चुनें।',
    exit_evaluation: 'क्या आप मूल्यांकन से बाहर निकलना चाहते हैं?',
    your_answers_will_not_be_saved: 'यदि आप अब बाहर निकलते हैं, तो आपके उत्तर सहेजे नहीं जाएंगे, और आपको ग्रेड नहीं मिलेगा',
    continue_evaluation: 'मूल्यांकन जारी रखें',
    leave_anyway: 'फिर भी बाहर निकलें',
    try_again: 'पुनः प्रयास करें!',
    passed_the_evaluation: 'आपने मूल्यांकन पास कर लिया है',
    start_the_course_again: 'आपने मूल्यांकन पास करने के लिए पर्याप्त ग्रेड नहीं प्राप्त किया। इसे पास करने के लिए कोर्स को फिर से शुरू करें।',
    evaluation_pending_approval: 'मूल्यांकन अनुमोदन हेतु लंबित है',
    notification_result_evaluation: 'आपको जल्द ही अपने मूल्यांकन के परिणाम के साथ एक सूचना प्राप्त होगी',
    write_here: 'यहाँ लिखें...',
    close: 'बंद करें',
    confirm: 'पुष्टि करें',
    sync_pending: 'समन्वयन लंबित है',
    view_certificate: 'प्रमाणपत्र देखें',
    // nuevos al 27-01-2025
    course_download_in_process: 'कोर्स डाउनलोड हो रहा है',
    course_is_downloading:
        'कृपया कुछ सेकंड का इंतजार करें। कोर्स डाउनलोड हो रहा है ताकि आप सभी सामग्री को बिना किसी समस्या के ऑफलाइन एक्सेस कर सकें।',
    downloaded_course: 'कोर्स सफलतापूर्वक डाउनलोड हो गया',
    you_can_train_offline: 'हो गया! अब आप ऑफलाइन प्रशिक्षण ले सकते हैं।',
    delete_offline_course: 'क्या आप इस कोर्स का ऑफलाइन डाउनलोड हटाना चाहते हैं?',
    not_view_course_offline: 'आप इस कोर्स को ऑफलाइन मोड में नहीं देख पाएंगे।',
    course_is_not_available: 'कोर्स अब उपलब्ध नहीं है...',
    not_available_offline: 'यह अब ऑफलाइन उपलब्ध नहीं है, लेकिन आप इसे जब चाहें फिर से डाउनलोड कर सकते हैं।',
    content_download_in_process: 'सामग्री डाउनलोड हो रही है',
    content_is_downloading: 'कृपया कुछ सेकंड का इंतजार करें। सामग्री डाउनलोड हो रही है ताकि आप इसे बिना किसी समस्या के ऑफलाइन एक्सेस कर सकें।',
    downloaded_content: 'सामग्री सफलतापूर्वक डाउनलोड हो गई',
    delete_offline_content: 'क्या आप ऑफलाइन सामग्री हटाना चाहते हैं?',
    not_view_content_offline: 'इसे हटाने पर, आप सामग्री को ऑफलाइन एक्सेस नहीं कर पाएंगे।',
    content_is_not_available: 'सामग्री अब उपलब्ध नहीं है...',
    download_offline: 'ऑफलाइन डाउनलोड करें',
    available_offline: 'ऑफलाइन उपलब्ध है',
    delete: 'मिटाना',

    //Stores
    your_progress_in_stores: 'स्टोर्स में आपकी प्रगति',
    map: 'मानचित्र',
    daily_survey: 'दैनिक सर्वेक्षण',
    survey: 'सर्वेक्षण',
    matutino: 'प्रातःकालीन',
    vespertino: 'सायंकालीन',
    form: 'प्रपत्र',
    enter_a_number: 'एक संख्या दर्ज करें',
    campaign_expiration: 'अभियान समाप्ति: ',
    store_indicators: 'स्टोर संकेतक',
    last_days: 'पिछले 30 दिनों के लिए प्रासंगिक',
    main_indicators: 'स्टोर में मुख्य संकेतकों की प्रगति जानें',
    store_information: 'स्टोर के इष्टतम परफेक्ट स्टोर स्तरों को पूरा करने के लिए प्रासंगिक जानकारी खोजें',
    perform_executions: 'स्टोर की स्थिति जानने के लिए निम्नलिखित निष्पादन करें',
    pending_mayus: 'लंबित',
    approved_mayus: 'स्वीकृत',
    in_review_mayus: 'समीक्षा में',
    redo_mayus: 'पुनः करें',
    visited_mayus: 'दौरा किया गया',
    visited_mayus_sync: 'देखा गया SYNC',
    visited_store_mayus: 'देखी गई दुकानें',
    checkin_realized_sync: 'देखी गई दुकानें SYNC',
    moderation_mayus: 'मध्यस्थता',
    review_mayus: 'समीक्षा',
    in_progress_mayus: 'प्रगति में',
    sync_pend_mayus: 'सिंक लंबित',
    locked_mayus: 'लॉक किया गया',
    complete_mayus: 'पूरा',
    perfect_store: 'परफेक्ट स्टोर',
    execution: 'निष्पादन',
    vouchers: 'वाउचर',
    send: 'भेजें',
    requires: 'आवश्यक ',
    variation: 'उतार-चढ़ाव',
    validity: 'वैधता: ',
    points: 'अंक',
    voucher_canceled: 'वाउचर रद्द किया गया',
    you_can_try_again: 'चिंता न करें! आप फिर से प्रयास कर सकते हैं।',
    voucher_successful: 'वाउचर सफलतापूर्वक पूरा हुआ!',
    successful_promo: 'प्रमोशन सफलतापूर्वक पूरा हुआ!',
    voucher_pending: 'वाउचर लंबित',
    wait_for_the_validation: 'अपने वाउचर की मान्यता के लिए प्रतीक्षा करें',
    your_code_is_being_scanned: 'आपका कोड स्कैन किया जा रहा है ⏳',
    view_qr: 'क्यूआर देखें',
    return_to_store: 'स्टोर पर वापस जाएं',
    stores_objective: 'यह स्टोर्स के उद्देश्य को पूरा करना चाहिए।',
    welcome_stores: 'हम आपको स्टोर्स में स्वागत करते हैं!',
    tip_day: 'यहां आप अपने दिन के स्टोर्स का दौरा कर सकते हैं, संबंधित सर्वेक्षण ले सकते हैं और अपनी प्रगति की समीक्षा कर सकते हैं।',
    close_mayus: 'बंद करें',
    select_form: 'शुरू करने के लिए एक फॉर्म चुनें',
    select_one_form: 'सर्वेक्षण शुरू करने के लिए आपको एक फॉर्म चुनना होगा।',
    answer_all_questions: 'जारी रखने के लिए आपको सभी प्रश्नों का उत्तर देना होगा।',
    schedule_not_found: 'आज के लिए शेड्यूल नहीं मिला।',
    form_not_found: 'शेड्यूल में फॉर्म नहीं मिला।',
    send: 'भेजें',
    check_in: 'चेक-इन',
    check_out: 'चेक-आउट',
    check_out_done: 'चेक-आउट पूरा हुआ',
    off_route: 'आप मार्ग से बाहर हैं, वापस जाने के लिए यहां क्लिक करें',
    search_barcode: 'बारकोड द्वारा खोजें',
    no_agenda_today: 'आज के लिए आपका कोई एजेंडा नहीं है!',
    no_agenda_week: 'आपके पास सप्ताह के लिए कोई एजेंडा नहीं है!',
    no_information_today: 'इस तारीख के लिए आपके पास कोई एजेंडा नहीं है, अगर आपके कोई प्रश्न हैं तो अपने पर्यवेक्षक से संपर्क करें।',
    no_information_week:
        'हम आपके उपयोगकर्ता के लिए जानकारी प्राप्त नहीं कर रहे हैं, यदि आपके कोई प्रश्न हैं तो कृपया अपने पर्यवेक्षक से संपर्क करें।',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'आपके पास कैमरा अनुमति नहीं है',
    activate_from_settings: 'जारी रखने के लिए इसे अपने डिवाइस की सेटिंग्स से सक्रिय करें।',
    modify_permissions: 'अनुमतियों को बदलें',
    complete_fields: 'एक स्टोर बनाने के लिए निम्नलिखित फ़ील्ड भरें',
    create: 'बनाएँ',
    store_name: 'स्टोर का नाम',
    enter_store_name: 'स्टोर का नाम दर्ज करें',
    sore_address: 'पता',
    enter_sore_address: 'स्टोर का पता दर्ज करें',
    cluster: 'क्लस्टर',
    store_phone: 'फोन',
    enter_sore_phone: 'स्टोर का फोन नंबर दर्ज करें',
    activate_survey: 'सर्वे 1.1 वेस्पर्टिनो को सक्रिय करने के लिए आपको स्टोर के लक्ष्यों को पूरा करना होगा। लक्ष्य: ',
    inactive_vespertino: 'वेस्पर्टिनो सक्रिय नहीं',
    active_vespertino: 'वेस्पर्टिनो सक्रिय',
    completed_your_mandatory_objectives: 'आपने दिन के अनिवार्य लक्ष्यों को पूरा कर लिया है, आप अब अपना वेस्पर्टिनो कर सकते हैं।',
    complete_now: 'अब पूरा करें',
    perform_later: 'बाद में करें',
    back_to_your_agenda: 'क्या आप अपने दिन के एजेंडा पर वापस जाना चाहते हैं?',
    return_to_the_current_day: 'आप अपने पिछले दिनों की गतिविधियाँ देख रहे हैं, अगर आप जारी रखने पर टैप करेंगे, तो आप वर्तमान दिन पर लौट आएंगे: ',
    continue: 'जारी रखें',
    reached_your_goal: 'आपने अपना लक्ष्य प्राप्त कर लिया है!',
    search_by_barcode: 'बारकोड द्वारा खोजें',
    scan_the_barcode: 'इस सर्वेक्षण की सूची में किसी भी उत्पाद का बारकोड स्कैन करें।',
    return_to_form: 'फॉर्म पर लौटें',
    product_not_found: 'उत्पाद नहीं मिला',
    code_does_not_match: 'कोड किसी भी उत्पाद से मेल नहीं खाता जो इस फॉर्म से संबंधित है।',
    search_another_product: 'कोई अन्य उत्पाद खोजें',
    form_submitted_successfully: ' सफल रहा है!',
    send_new_survey: 'यदि चाहें तो आप एक नया सर्वेक्षण भेज सकते हैं।',
    no_agenda_for_today: 'आज के लिए कोई एजेंडा नहीं है!',
    consult_your_supervisor: 'इस तारीख के लिए आपके पास कोई एजेंडा नहीं है, किसी भी संदेह के लिए अपने पर्यवेक्षक से परामर्श करें।',
    visiting_your_store: 'आप अपनी दुकान पर जा रहे हैं ',
    you_can_check_out: 'आप सर्वेक्षण को पूरा किए बिना चेक-आउट कर सकते हैं: ',
    you_met_the_goal: 'आपने लक्ष्य पूरा कर लिया है, फॉर्म पूरा करने की आवश्यकता नहीं है।',
    you_must_complete_the_survey: 'चेक-आउट करने के लिए आपको सर्वेक्षण पूरा करना होगा: ',
    checkin_blocked: 'चेक-इन अवरुद्ध है',
    close_the_open_checkin: 'जारी रखने के लिए आपको खुले चेक-इन को बंद करना होगा।',
    close_the_checkin_opened_in: 'जारी रखने के लिए आपको इस स्थान पर खुले चेक-इन को बंद करना होगा: ',
    checkin_out_of_range: 'चेक-इन सीमा से बाहर है',
    more_meters_from_the_store: 'आप दुकान से 150 मीटर से अधिक दूर हैं।',
    now_is_your_turn: 'अब आपकी बारी है!',
    surveys_in_progress: 'आपके पास प्रगति में सर्वेक्षण हैं: ',
    unfinished_surveys: 'आपके पास अपूर्ण सर्वेक्षण हैं: ',
    want_to_checkout: 'क्या आप वाकई चेक-आउट करना चाहते हैं?',
    selected_store: 'चयनित दुकान',
    checkout_blocked: 'चेक-आउट अवरुद्ध है',
    uncompleted_forms: 'आपके पास अपूर्ण फॉर्म हैं!',
    checkout_anyway: 'क्या आप फिर भी चेक-आउट करना चाहते हैं?',
    go_to_survey: 'सर्वेक्षण पर जाएं',
    take_the_survey: 'अब आप सर्वेक्षण पूरा कर सकते हैं!',
    validity: 'वैधता: ',
    search_store: 'स्टोर खोजें...',
    no_results_for_your_search: 'आपकी खोज के लिए कोई परिणाम नहीं मिला',
    find_another_store: 'कोई और दुकान खोजें',
    //nuevos al 21-11-2024
    loading: 'लोड हो रहा है...',
    error_getting_data: 'डेटा प्राप्त करने में त्रुटि।',
    no_information_to_display: 'दिखाने के लिए कोई जानकारी नहीं है।',
    unzipping: 'कंप्रेसन निकाल रहा है...',
    saving: 'सहेजना',
    loading_stores: 'दुकानें लोड हो रही हैं...',
    getting_stores: 'दुकानें प्राप्त हो रही हैं...',
    request_has_failed: 'अधिकतम पुनः प्रयास संख्या तक पहुँच गया। अनुरोध विफल हो गया।',
    a_few_minutes: 'दुकानें लोड हो रही हैं...\nइस प्रक्रिया में कुछ मिनट लग सकते हैं।',
    //nuevos al 27-01-2025
    assets_download_completed: 'परफेक्ट स्टोर के संसाधनों का डाउनलोड पूरा हो गया',
    perfect_store_download: 'परफेक्ट स्टोर की सफलता की फोटो का डाउनलोड पूरा हो गया',
    perfect_store_error: 'परफेक्ट स्टोर के संसाधनों के डाउनलोड में त्रुटि',
    connection_interrupted: 'कनेक्शन में विघ्न, कनेक्शन पुनः स्थापित होने पर सफलता की फोटो अनज़िप की जाएगी',
    decompressing_perfect_store: 'परफेक्ट स्टोर डाउनलोड हो रहा है',
    downloading_perfect_store: 'परफेक्ट स्टोर डाउनलोड हो रहा है',
    saving_perfect_store: 'परफेक्ट स्टोर सहेजा जा रहा है',
    remain_downloaded: '\nडाउनलोड करने के लिए शेष ',
    assets: ' संसाधन।',
    download_complete: 'डाउनलोड पूरा हुआ',

    //Portfolio
    no_brands_to_show: 'दिखाने के लिए कोई ब्रांड नहीं',
    no_products_to_show: 'दिखाने के लिए कोई उत्पाद नहीं',
    try_again_later: 'बाद में पुनः प्रयास करें',
    portfolio: 'पोर्टफोलियो',
    select_one: 'हमारे ब्रांडों में से एक को चुनें उनके उत्पादों और सेवाओं को देखने के लिए।',
    learn_about: 'हमारे ऐप में उत्पादों और सेवाओं की पूरी रेंज के बारे में जानें।',
    //nuevos al 01-08-2024
    brand: 'ब्रांड',
    description: 'विवरण',
    ingredients: 'सामग्री',
    data_sheet: 'डेटा शीट',

    //Benefits
    points_can_be_exchanged: 'के लिए बदला जा सकता है:',
    approved: 'स्वीकृत',
    cancelled: 'रद्द किया गया',
    pending: 'लंबित',
    redeemed: 'भुनाया गया',
    added_points: 'अंक जोड़े गए',
    all: 'सभी',
    my_points: 'मेरे अंक',
    your_points: 'आपके अंक',
    delivered: 'वितरित',
    no_benefits: 'अभी तक कोई लाभ नहीं',
    add_points: 'अपनी बातचीत के साथ अंक अर्जित करें और उन्हें भुनाएं',
    no_history: 'अभी तक कोई इतिहास नहीं',
    redeem_your_points: 'अपने अंकों को भुनाएं और आप अपने लाभ इतिहास को यहां देखेंगे',
    pending_approval: 'स्वीकृति लंबित है',
    when_it_is_approved: 'जब यह स्वीकृत होगा, तो आप इसे अपने लाभ इतिहास में परिलक्षित देखेंगे',
    unredeemed_benefit: 'अभिनिर्मित लाभ',
    you_dont_have_enough_points: 'इस लाभ को भुनाने के लिए आपके पास पर्याप्त अंक नहीं हैं',
    accept: 'स्वीकार करें',
    units_available: ' उपलब्ध इकाइयाँ',
    redeem_benefit: 'लाभ भुनाएं',
    benefits_mayus: 'लाभ',
    history: 'इतिहास',
    there_was_a_mistake: 'एक गलती थी',

    //Vouchers
    complete_to_redeem_the_voucher: 'वाउचर भुनाने के लिए पूरा करें',
    valid_until: 'तक मान्य: ',
    quantity_purchased: 'खरीदी गई मात्रा: ',
    redeem: 'भुनाएं',
    lumps: 'गांठें',
    voucher_redeemed: 'वाउचर सफलतापूर्वक भुनाया गया',
    error_redeeming_voucher: 'वाउचर भुनाते समय एक त्रुटि हुई। पुनः प्रयास करें।',
    validate_and_redeem_vouchers: 'वाउचर को मान्य करें और भुनाएं',
    to_get_started: 'शुरू करने के लिए, अपने वाउचर का क्यूआर दर्ज करें या अपनी कैमरा के साथ स्कैन करें',
    write_your_code: 'अपना कोड लिखें...',
    validate: 'सत्यापित करें',
    back_to_store: 'स्टोर पर वापस जाएं',
    scan_qr: 'QR स्कैन करें',
    scan_on_the_voucher: 'शुरू करने के लिए, वाउचर का QR स्कैन करें',
    view_history: 'इतिहास देखें',
    voucher_history: 'वाउचर इतिहास',
    voucher_history_description:
        'यह इतिहास आपको किए गए रिडेम्प्शन को सटीकता से ट्रैक करने की अनुमति देता है, जिससे आपके संचित पुरस्कारों का पालन और प्रबंधन करना आसान हो जाता है।',
    see_more: 'और देखें',
    see_less: 'कम देखें',

    //Faltantes
    upload_image: 'छवि अपलोड करें',
    uploaded_image: 'अपलोड की गई छवि',
    photo: 'फोटो',
    edit: 'संपादित करें',
    delete: 'हटाएं',
    enter_a_comment: 'एक टिप्पणी दर्ज करें',
    enter_a_value: 'एक मान दर्ज करें',
    want_to_check_out: 'क्या आप सुनिश्चित हैं कि आप चेक-आउट करना चाहते हैं?',
    not_check_in_again: 'एक बार पुष्टि करने के बाद, आप अपनी अगली यात्रा तक फिर से चेक-इन नहीं कर सकेंगे।',

    //Alert
    alert: 'चेतावनी',
    enter_characters: 'आपको उपसर्ग के बाद 10 वर्ण दर्ज करने होंगे',
    numerical_field: 'संपादित किया जाने वाला फ़ील्ड केवल संख्यात्मक होना चाहिए, बिना रिक्त स्थान या अक्षरों के।',
    enter_date_of_birth: 'कृपया YYYY-MM-DD प्रारूप में मान्य जन्म तिथि दर्ज करें।',
    session_expired: 'सत्र समाप्त हो गया',
    your_session_has_expired: 'आपका सत्र समाप्त हो गया है। कृपया पुनः प्रयास करें।',
    error: 'त्रुटि',
    error_occurred: 'पासवर्ड बदलने का प्रयास करते समय एक त्रुटि हुई।',
    email_verification_code_incorrect: 'ईमेल सत्यापन कोड गलत है।',
    phone_verification_code_incorrect: 'फ़ोन सत्यापन कोड गलत है।',
    no_checkin_found: 'चेक-इन नहीं मिला।',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
